import React from 'react';
import {MasterLayout} from 'components/layouts';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';
import {Profile} from 'components/my-business/profile';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessProfilePage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessProfilePage;
  }

  render() {
    return (
      <MasterLayout isActive='my-business'>
        <BusinessLayout active='profile'>
          <Profile/>
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessProfilePage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessProfilePage.jsx